require('../bootstrap');

import env from '../config/env';
import router from '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;

const store = {
    state: {
        user: {
            name: '',
            photo: '',
            company_logo: '',
            job: '',
            email: '',
            is_admin: '',
            password_expired: 0,
            id: 0
        },
        tour_web: true,
        authenticated: false,
        notifications: 0,
        token: '',
        api: baseURL,
        url: normalURL,
        breadcrumbs: [{ name: "Home", route: "/" }]
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        }
    },
    mutations: {
        auth(state, token) {

            if (token != null && token != undefined) {
                state.authenticated = true;
                state.token = token;

                localStorage.clear();
                localStorage.setItem('token', token);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        updateNotifications(state, data) {
            state.notifications = Number(state.notifications) + 1;
        },
        skipTour(state) {
            state.tour_web = false;
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then(response => {
                    state.user.id = response.data.id;
                    state.user.name = response.data.name;
                    state.user.email = response.data.email;
                    state.user.photo = state.url + "user/image/" + response.data.id;
                    state.user.company_logo = state.url + "companies/logo/" + response.data.company_id;
                    state.user.cellphone = response.data.cellphone;
                    state.user.access_nivel = response.data.access_nivel;
                    state.user.department_id = response.data.department_id;
                    state.user.accept_terms = response.data.accept_terms;
                    state.user.password_expired = response.data.password_expired;
                    state.user.tour_web = response.data.tour_web;
                    state.user.company_id = response.data.company_id;

                    if (state.user.tour_web == 1) {
                        this.commit('skipTour');
                    }

                    localStorage.setItem('accept_terms', response.data.accept_terms);
                    localStorage.setItem('access_nivel', '3');

                })
                .catch(error => {
                    localStorage.clear();

                    router.push('/login');
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        }
    },
    actions: {
        initialize(context) {
            const token = localStorage.getItem('token');
            context.commit('auth', token);
        }
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js